const AiChatUserInputType = {
  MESSAGE       : 'MESSAGE',
  STOP_STREAMING: 'STOP_STREAMING',
  EDIT_MESSAGE  : 'EDIT_MESSAGE'
}

export default AiChatUserInputType
